import getStore from '@ve/services/getStore/getStore';
import processProducts from './processProducts';

export default ({
                    tourSearchModel,
                    searchFormModel,
                    currentSearchModel,
                    mealsRepository,
                }) => getStore({
    name: 'mapForFilters',
    backboneMap: [{
        fields: ['selectedTabDate', 'productType', 'operators', 'isExclusive'],
        model: tourSearchModel.get('filterCriteria'),
    }, {
        fields: [{
            meals: {
                field: 'model',
                action: (model, meals) => (meals ? meals.pluck('id') : []),
            },
        }],
        model: searchFormModel.get('meals'),
    }, {
        fields: [{
            warranted: 'model',
        }],
        model: searchFormModel.get('warranted'),
    }, {
        fields: [{
            checkInDateRange: {
                field: 'checkInDateRange',
                action: (model, checkInDateRange) => ({
                    from: checkInDateRange?.get('from') || null,
                    to: checkInDateRange?.get('to') || null,
                }),
            },
        }],
        model: currentSearchModel,
    }, {
        fields: [
            'loadingState',
            {
                products: {
                    field: 'syncTourProductsWithIsExclusive',
                    action() {
                        const products = tourSearchModel.get('syncTourProductsWithIsExclusive');
                        return processProducts(products, tourSearchModel);
                    },
                },
                filteredTourProducts: {
                    field: 'filteredTourProductsAll',
                    action() {
                        const products = tourSearchModel.get('filteredTourProductsAll');
                        return processProducts(products, tourSearchModel);
                    },
                },
            }],
        model: tourSearchModel,
    }],
    storeOptions: {
        state: {
            mealsRepository: mealsRepository.map((meal) => meal.pick('id', 'name', 'code')),
        },
    },
});